module.exports = __webpack_public_path__ + "static/media/dots.4eb10483.png";